export default __webpack_public_path__ + "static/desk3500_front-92b85625f3266b362e307dbe3f6facd6.png";